import React, { useContext } from "react";
import "./addresslist.css";
import { Container, Row, Col } from "react-bootstrap";
import plus from "../../../Assets/Images/plusadd.png";
import { Link } from "react-router-dom";
// import close from '../../../Assets/Images/close.png'
import { LangContext } from "../../../App";
import string from "../../../Assets/Localization/Local";

const Addresslist = () => {
  const { lang } = useContext(LangContext);
  string.setLanguage(lang);

  return (
    <div className="addresslist">
      <Container fluid>
        <Row>
          <Col lg="12">
            <h2 className="text-center mb-5">{string.addresslist}</h2>
          </Col>
          <Col lg="12">
            <Link to="/Catch-It/PaymentView">
              <div className="addresslist-addaddress mb-5">
                <div>
                  <img src={plus} alt="plus" />
                  <h3 className="text-white">{string.addnewaddress}</h3>
                </div>
              </div>
            </Link>
          </Col>
        </Row>
        <Row>
          <Col lg="6" md="6">
            <div className="addresslist-addressname">
              <p>12 شارع المترو شقه 2 - حدائق حلوان - القاهرة</p>
              <div className="addresslist-addaddressoptions">
                <i
                  style={{ backgroundColor: "#CE2323" }}
                  className="fa fa-trash"
                ></i>
                <i
                  style={{ backgroundColor: "#0071BC" }}
                  className="fas fa-map-marker-alt"
                ></i>
                <i
                  style={{ backgroundColor: "#39B54A" }}
                  className="fas fa-pen"
                ></i>
              </div>
            </div>
          </Col>
          <Col lg="6" md="6">
            <div className="addresslist-addressname">
              <p>12 شارع المترو شقه 2 - حدائق حلوان - القاهرة</p>
              <div className="addresslist-addaddressoptions">
                <i
                  style={{ backgroundColor: "#CE2323" }}
                  className="fa fa-trash"
                ></i>
                <i
                  style={{ backgroundColor: "#0071BC" }}
                  className="fas fa-map-marker-alt"
                ></i>
                <i
                  style={{ backgroundColor: "#39B54A" }}
                  className="fas fa-pen"
                ></i>
              </div>
            </div>
          </Col>
          <Col lg="6" md="6">
            <div className="addresslist-addressname">
              <p>12 شارع المترو شقه 2 - حدائق حلوان - القاهرة</p>
              <div className="addresslist-addaddressoptions">
                <i
                  style={{ backgroundColor: "#CE2323" }}
                  className="fa fa-trash"
                ></i>
                <i
                  style={{ backgroundColor: "#0071BC" }}
                  className="fas fa-map-marker-alt"
                ></i>
                <i
                  style={{ backgroundColor: "#39B54A" }}
                  className="fas fa-pen"
                ></i>
              </div>
            </div>
          </Col>
          <Col lg="6" md="6">
            <div className="addresslist-addressname">
              <p>12 شارع المترو شقه 2 - حدائق حلوان - القاهرة</p>
              <div className="addresslist-addaddressoptions">
                <i
                  style={{ backgroundColor: "#CE2323" }}
                  className="fa fa-trash"
                ></i>
                <i
                  style={{ backgroundColor: "#0071BC" }}
                  className="fas fa-map-marker-alt"
                ></i>
                <i
                  style={{ backgroundColor: "#39B54A" }}
                  className="fas fa-pen"
                ></i>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Addresslist;
